/* MV cart drawer add-ons, mobile sticky add-to-cart, Klaviyo hold, image warm-up (2026-09-28). Loaded from layout/theme.liquid. */

/* ---------- Cart drawer: "Complete the look" one-tap add ---------- */
(function () {
  // The drawer's inner HTML is replaced on every cart change, so listen on the document.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mv-upsell-select]');
    if (!select) return;
    const card = select.closest('.mv-upsell__card');
    const option = select.options[select.selectedIndex];
    card.querySelector('[data-mv-quick-add]').dataset.mvQuickAdd = select.value;
    if (option && option.dataset.price) card.querySelector('[data-mv-upsell-price]').textContent = option.dataset.price;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mv-quick-add]');
    if (!button || button.disabled) return;
    const drawer = document.querySelector('cart-drawer');
    const error = button.closest('.mv-upsell')?.querySelector('.mv-upsell__error');
    if (!drawer) return;

    button.disabled = true;
    button.classList.add('is-loading');
    if (error) error.hidden = true;

    try {
      // Same single-item payload + publish shape as Dawn's product-form.js, so Dawn's cartUpdate listeners get what they expect.
      const variantId = button.dataset.mvQuickAdd;
      const sections = drawer.getSectionsToRender().map((s) => s.id);
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add this item.');

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mv-upsell', productVariantId: variantId, cartData: state });
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
    } catch (e) {
      if (error) {
        error.textContent = e.message;
        error.hidden = false;
      }
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
})();

/* ---------- Klaviyo popup: never over the open cart drawer or on /cart (Henry 2026-09-28) ----------
   Klaviyo has no API to close or block a form (docs: only the window "klaviyoForms" open/close events), so while the
   drawer is open (or on /cart) an open popup is kept hidden and its body scroll lock lifted; when the drawer closes it
   shows as normal. Klaviyo's own targeting also excludes /cart; this is the fallback. */
(function () {
  const onCartPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname);
  const LOCK = 'klaviyo-prevent-body-scrolling';
  let klOpen = false;
  let held = false;
  let hadLock = false;

  const popups = () =>
    [...document.querySelectorAll('div[aria-label="POPUP Form"]')].map((d) => d.parentElement || d);
  const drawerOpen = () => document.querySelector('cart-drawer')?.classList.contains('active');

  function sync() {
    if (!klOpen && popups().length) klOpen = true;
    const hold = klOpen && (onCartPage || drawerOpen());
    if (hold) {
      if (!held) hadLock = document.body.classList.contains(LOCK);
      held = true;
      popups().forEach((p) => p.style.setProperty('display', 'none', 'important'));
      if (document.body.classList.contains(LOCK)) {
        hadLock = true;
        document.body.classList.remove(LOCK);
      }
    } else if (held) {
      held = false;
      popups().forEach((p) => p.style.removeProperty('display'));
      if (hadLock && klOpen && popups().length) document.body.classList.add(LOCK);
    }
  }

  if (onCartPage) document.documentElement.classList.add('mv-on-cart-page');
  window.addEventListener('klaviyoForms', (e) => {
    if (e.detail.type === 'open') klOpen = true;
    if (e.detail.type === 'close') klOpen = false;
    setTimeout(sync, 0);
  });
  new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  sync();
})();

/* ---------- Cart drawer: warm its lazy images on intent, so tiles aren't blank for a second when it opens ---------- */
(function () {
  const warm = () =>
    document.querySelectorAll('#CartDrawer img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  ['pointerenter', 'touchstart', 'focusin'].forEach((type) =>
    document.addEventListener(
      type,
      (event) => {
        if (event.target.closest && event.target.closest('#cart-icon-bubble, button[name="add"]')) warm();
      },
      { passive: true, capture: true }
    )
  );
})();

/* ---------- Cart drawer: discount code bar ---------- */
(function () {
  // Fallback for browsers without overflow: clip: never let focus scroll the drawer panel sideways.
  document.addEventListener('focusin', (event) => {
    const inner = event.target.closest('#CartDrawer .drawer__inner');
    if (inner && inner.scrollLeft) inner.scrollLeft = 0;
  });

  const appliedCodes = () =>
    [...document.querySelectorAll('#CartDrawer [data-mv-discount-remove]')].map((b) => b.dataset.mvDiscountRemove);

  // Shopify Cart Ajax API: POST /cart/update.js {discount: 'A,B'} replaces the cart's codes; '' clears them.
  async function setCodes(codes) {
    const response = await fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    if (!response.ok) throw new Error('Something went wrong. Please try again.');
    return response.json();
  }

  async function rerender() {
    const drawer = document.querySelector('cart-drawer');
    const ids = drawer.getSectionsToRender().map((s) => s.id);
    const sections = await (await fetch(`${window.location.pathname}?sections=${ids.join(',')}`)).json();
    drawer.renderContents({ sections });
  }

  function showError(message) {
    const el = document.querySelector('#CartDrawer .mv-discount__error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-mv-discount-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input');
    const button = form.querySelector('button');
    const code = input.value.trim();
    if (!code) return;
    const current = appliedCodes();
    if (current.some((c) => c.toLowerCase() === code.toLowerCase())) {
      showError(`${code} is already applied.`);
      return;
    }
    button.disabled = true;
    try {
      const cart = await setCodes([...current, code]);
      const result = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (!result || !result.applicable) {
        await setCodes(current); // take the rejected code back off so it doesn't sit on the cart
        showError(`${code} isn't valid for the items in your cart.`);
        button.disabled = false;
        return;
      }
      await rerender();
    } catch (e) {
      showError(e.message);
      button.disabled = false;
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mv-discount-remove]');
    if (!button) return;
    button.disabled = true;
    try {
      await setCodes(appliedCodes().filter((c) => c !== button.dataset.mvDiscountRemove));
      await rerender();
    } catch (e) {
      showError(e.message);
      button.disabled = false;
    }
  });
})();

/* ---------- Mobile sticky add-to-cart ---------- */
if (!customElements.get('mv-sticky-atc')) {
  customElements.define(
    'mv-sticky-atc',
    class MvStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-mv-sticky-button]');
        this.label = this.querySelector('[data-mv-sticky-label]');
        this.priceEl = this.querySelector('[data-mv-sticky-price]');
        this.compareEl = this.querySelector('[data-mv-sticky-compare]');
        this.variantEl = this.querySelector('[data-mv-sticky-variant]');
        this.img = this.querySelector('[data-mv-sticky-img]');
        this.fallbackSrc = this.dataset.fallbackSrc;
        this.pastButtons = false;
        this.atFooter = false;

        const mainButton = this.mainButton();
        const buttonsWrap = mainButton?.closest('.product-form__buttons');
        if (!mainButton || !buttonsWrap) return;

        // Show once the main buttons have scrolled up out of view; hide again over the footer.
        this.buttonsObserver = new IntersectionObserver(([entry]) => {
          this.pastButtons = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle();
        });
        this.buttonsObserver.observe(buttonsWrap);

        const footer = document.querySelector('.footer, footer');
        if (footer) {
          this.footerObserver = new IntersectionObserver(([entry]) => {
            this.atFooter = entry.isIntersecting;
            this.toggle();
          });
          this.footerObserver.observe(footer);
        }

        // Mirror the main button's sold-out / loading state (Dawn toggles it in place).
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });

        // Dawn adds body.overflow-hidden while the cart drawer or menu drawer is open: step out of the way.
        this.bodyObserver = new MutationObserver(() => this.toggle());
        this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        // The bar pins under the sticky header: its height changes with the viewport, so re-measure on scroll and resize.
        this.onViewport = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.place();
          });
        };
        window.addEventListener('scroll', this.onViewport, { passive: true });
        window.addEventListener('resize', this.onViewport);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.syncVariant(event.data.variant);
          });
        }

        this.syncPrice();
        this.syncButton();
      }

      disconnectedCallback() {
        this.buttonsObserver?.disconnect();
        this.footerObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.bodyObserver?.disconnect();
        if (this.onViewport) {
          window.removeEventListener('scroll', this.onViewport);
          window.removeEventListener('resize', this.onViewport);
        }
        this.unsubscribe?.();
      }

      mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      place() {
        // Keep the bar's top edge on the sticky header's bottom edge (0 if the header is off screen).
        const header = document.querySelector('.section-header');
        const bottom = header ? header.getBoundingClientRect().bottom : 0;
        this.style.setProperty('--mv-sticky-top', `${Math.max(0, Math.round(bottom))}px`);
      }

      toggle() {
        // Any overflow-hidden* body class = a drawer or modal is open (the menu drawer uses overflow-hidden-tablet).
        const show = this.pastButtons && !this.atFooter && !/(^|\s)overflow-hidden/.test(document.body.className);
        this.place();
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.inert = !show;
        this.button.tabIndex = show ? 0 : -1;
      }

      syncButton() {
        const main = this.mainButton();
        if (!main) return;
        const loading = main.classList.contains('loading');
        this.button.disabled = main.hasAttribute('disabled') && !loading;
        this.button.classList.toggle('loading', loading);
        this.button.setAttribute('aria-disabled', loading || main.getAttribute('aria-disabled') === 'true' ? 'true' : 'false');
        this.button.setAttribute('aria-busy', loading ? 'true' : 'false');
        const text = main.querySelector('span')?.textContent.trim();
        if (text) {
          this.label.textContent = text;
          this.button.setAttribute('aria-label', text);
        }
      }

      syncPrice() {
        // Dawn writes the new variant's price into #price-<section> before it publishes variantChange.
        const source = document.querySelector(`#price-${this.sectionId} .price`);
        if (!source) return;
        const sale = source.classList.contains('price--on-sale');
        const current = source.querySelector(sale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        if (current && current.textContent.trim()) this.priceEl.textContent = current.textContent.trim();
        // Crossed-out compare-at price, shown only while the page itself shows the sale.
        if (!this.compareEl) return;
        // Currency code dropped here only (the live price beside it keeps it) so the line fits beside the button.
        const compare = sale ? source.querySelector('.price__sale .price-item--regular')?.textContent.trim().replace(/\s+[A-Z]{3}$/, '') : '';
        this.compareEl.textContent = compare || '';
        this.compareEl.hidden = !compare;
      }

      syncVariant(variant) {
        this.syncPrice();
        if (!variant) return;
        if (this.variantEl) this.variantEl.textContent = variant.title;
        if (!this.img) return;
        const src = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
        this.img.removeAttribute('srcset');
        if (src) {
          const url = new URL(src, window.location.origin);
          url.searchParams.set('width', '120');
          this.img.src = url.toString();
        } else if (this.fallbackSrc) {
          this.img.src = this.fallbackSrc;
        }
      }
    }
  );
}
